module.exports = __webpack_public_path__ + "img/message.0a55d396.png";